import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Costcenter } from './costcenter';
import { environment } from '../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class CostcenterService {
	baseUrl = environment.baseUrl;
  private CostCenterUrl = this.baseUrl + '/api/costcenter';  // URL to web api

  //private CostCenterDetailsUrl = this.baseUrl + '/api/costcenter/getcostcenterdeta';  // URL to web api
  private CostCenterListUrl = this.baseUrl + '/api/costcenter/costcenterlist';  // URL to web api
  private CostCenterDetailsUrl = this.baseUrl + '/api/costcenter/getcostcenterDetails';  // URL to web api
   
  constructor( 
    private http: HttpClient
  ) { }
 
  getCostcenters (): Observable<Costcenter[]> {
	return this.http.get<Costcenter[]>(this.CostCenterUrl)
  }
   GetCostCenterDetails(costcenterid: number): Observable<Costcenter> {
    const url = `${this.CostCenterDetailsUrl}/${costcenterid}`;
    return this.http.get<Costcenter>(url);
  } 
  getCostcenterlist (): Observable<Costcenter[]> {
    return this.http.get<Costcenter[]>(this.CostCenterListUrl)
  }

  getCostcenter(costcenterid: number): Observable<Costcenter> {
    const url = `${this.CostCenterUrl}/${costcenterid}`;
    return this.http.get<Costcenter>(url);
  }
 
  addCostCenter (costcenter: Costcenter): Observable<Costcenter> {

    return this.http.post<Costcenter>(this.CostCenterUrl, costcenter, httpOptions);
  }
     
  deleteCostCenter (costcenter: Costcenter | number): Observable<Costcenter> {
    const costcenterid = typeof costcenter === 'number' ? costcenter : costcenter.costcenterid;
    const url = `${this.CostCenterUrl}/${costcenterid}`;
 
    return this.http.delete<Costcenter>(url, httpOptions);
  }
 
  updateCostCenter (costcenter: Costcenter): Observable<any> {
    return this.http.put(this.CostCenterUrl, costcenter, httpOptions);
  }

}